import {createSlice, configureStore} from "@reduxjs/toolkit";

const initState = {
    name: "nevrycards",
    value: 0
};

const nevrySlice = createSlice({
    name: "nevrycards",
    initialState: initState,
    reducers:{
        addVal(state,action){
            state.value += action.payload;
        },
        remVal(state,action){
            state.value -= action.payload;
        }
    }
});

export const nevryActions = nevrySlice.actions;
const store = configureStore({reducer: {nevry: nevrySlice.reducer}});
export default store;